import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import onEnterPress from 'hb-react/shared/utils/onEnterPress';

interface NavItemProps {
  icon: React.ReactNode;
  id: string;
  isActive: boolean;
  onClick: () => void;
  title: string;
}

const NavItem = ({ icon, id, isActive, onClick, title }) => (
  <Item
    key={id}
    isActive={isActive}
    onClick={() => !isActive && onClick()}
    onKeyPress={onEnterPress(() => onClick())}
    tabIndex={0}
    data-testid="navigation-item"
  >
    <IconWrapper isActive={isActive}>{icon}</IconWrapper> {title}
  </Item>
);

export default NavItem;

interface StyleAttrs {
  isActive: NavItemProps['isActive'];
}

const IconWrapper = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['isActive'].includes(prop),
  })
  .attrs(({ isActive }: StyleAttrs) => ({
    color: isActive ? 'primary' : '#6C757D',
    pr: '10px',
  }))<StyleAttrs>``;

const Item = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['isActive'].includes(prop),
  })
  .attrs(({ isActive }: StyleAttrs) => ({
    bg: isActive && '#ebf1fd',
    color: isActive ? 'primary' : '#6C757D',
    alignItems: 'center',
    height: '52px',
    px: 4,
  }))<StyleAttrs>`
  cursor: pointer;
`;
